export default __webpack_public_path__ + "popup-close-small-icon.svg";